import { render, staticRenderFns } from "./tag-manager-page.vue?vue&type=template&id=6979241a&"
import script from "./tag-manager-page.vue?vue&type=script&lang=js&"
export * from "./tag-manager-page.vue?vue&type=script&lang=js&"
import style0 from "./tag-manager-page.vue?vue&type=style&index=0&id=6979241a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports